import { Component, OnInit } from '@angular/core';
import { AccountService } from '@app/teacher/services/account.service';
import { Profile, LessonStatus } from '@app/definitions/interfaces';
import { GROUPS } from '@app/app.constants';
import { StudentAccount } from '@df/interfaces';

@Component({
    selector: 'app-profile-info',
    templateUrl: './profile-info.component.html',
    styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent implements OnInit {
    lesson_statuses = LessonStatus;
    studentAccount: StudentAccount;
    student_amount: number = 0;

    headerName: string = 'Ваш профиль';
    profile: Profile;
    is_teacher: boolean = false;
    is_teacher_helper: boolean = false;
    is_parent: boolean = false;
    is_student: boolean = false;
    is_super_user: boolean = false;

    constructor(private accountService: AccountService) {}

    ngOnInit() {
        this.accountService.getProfileData().subscribe(resp => {
            this.profile = resp.data;

            this.checkGroup();
        });
    }

    private checkGroup(): void {
        if (this.profile.group.name === GROUPS.PARENT) {
            this.is_parent = true;
        }

        if (this.profile.group.name === GROUPS.TEACHER) {
            this.is_teacher = true;
        }

        if (this.profile.group.name === GROUPS.TEACHER_HELPER) {
            this.is_teacher_helper = true;
        }

        if (this.profile.group.name === GROUPS.STUDENT) {
            this.is_student = true;
            this.getBankData();
        }

        if (this.profile.group.name === GROUPS.SUPER_NAVIGATOR) {
            this.is_super_user = true;
        }
    }

    private getBankData(): void {
        setTimeout(() => {
            const groupInstance = this.accountService.currentGroupInstance;
            this.accountService.getStudentAccount(groupInstance).subscribe(resp => {
                this.studentAccount = resp;
                this.student_amount = Math.round(resp.amount);
            });
        }, 2000);
    }
}
